import { FC, useMemo } from 'react';

import { IIcon } from './interface.ts';
import { IconTypes } from './constants.ts';
import Image from '../Image/Image.tsx';
import ArrowRight from '/assets/icons/arrow-right.svg?url';
import Facebook from '/assets/icons/Facebook.svg?url';
import Hamburger from '/assets/icons/hamburger.svg?url';
import Close from '/assets/icons/close.svg?url';
import Pinterest from '/assets/icons/Pinterest.svg?url';
import Back from '/assets/icons/back.svg?url';
import DoubleArrowUp from '/assets/icons/double-arrow-up.svg?url';
import Play from '/assets/icons/play.svg?url';
import Pause from '/assets/icons/pause.svg?url';
import Refresh from '/assets/icons/Refresh.svg?url';

const Icon: FC<IIcon> = ({ type, size }) => {
  const icon = useMemo(() => {
    switch (type) {
      case IconTypes.arrowRight:
        return ArrowRight;
      case IconTypes.facebook:
        return Facebook;
      case IconTypes.hamburger:
        return Hamburger;
      case IconTypes.close:
        return Close;
      case IconTypes.pinterest:
        return Pinterest;
      case IconTypes.back:
        return Back;
      case IconTypes.play:
        return Play;
      case IconTypes.pause:
        return Pause;
      case IconTypes.doubleArrowUp:
      case IconTypes.doubleArrowLeft:
      case IconTypes.doubleArrowRight:
        return DoubleArrowUp;
      case IconTypes.refresh:
        return Refresh;
      default: {
        return null;
      }
    }
  }, [type]);

  const classList = useMemo(() => {
    const list = ['icon'];

    if (size) {
      list.push(`icon--${size}`);
    }

    switch (type) {
      case IconTypes.arrowRight:
        list.push(`icon--arrow-right`);
        break;
      case IconTypes.facebook:
        list.push(`icon--facebook`);
        break;
      case IconTypes.hamburger:
        list.push(`icon--hamburger`);
        break;
      case IconTypes.close:
        list.push(`icon--close`);
        break;
      case IconTypes.pinterest:
        list.push(`icon--pinterest`);
        break;
      case IconTypes.back:
        list.push(`icon--back`);
        break;
      case IconTypes.doubleArrowUp:
        list.push(`icon--double-arrow-up`);
        break;
      case IconTypes.doubleArrowLeft:
        list.push(`icon--double-arrow-left`);
        break;
      case IconTypes.doubleArrowRight:
        list.push(`icon--double-arrow-right`);
        break;
      case IconTypes.refresh:
        list.push(`icon--refresh`);
        break;
    }

    return list.join(' ');
  }, [size, type]);

  return icon ? <Image alt="icon" className={classList} src={icon} /> : null;
};

export default Icon;
